import { Navigate } from 'react-router-dom';
import React from 'react';
import OrderPage from './orderPage/OrderPage';
import OrderCompletedPage from './orderPage/orderCompletion/OrderCompletedPage';
import ChooseOrderPage from './orderPage/ChooseOrderPage';
import WaitingList from './orderPage/WaitingList';
import WaitingListCompletedPage from './orderPage/WaitingListCompletedPage';
import { CustomerFacingWidgetWrapper } from './CustomerFacingWidgetWrapper';
import { ManageBookingPage } from './manageBookingPage/ManageBookingPage';
import { ManagePassesPage } from './managePassesPage/ManagePassesPage';
import { PassLogin } from './managePassesPage/PassLogin';
import { PassDashboard } from './managePassesPage/PassDashboard';
import { PassDetailView } from './managePassesPage/PassDetailView';
import { PassSchedule } from './managePassesPage/PassSchedule';
import { BuyPassPage } from './managePassesPage/BuyPassPage';
import { BuyPassCheckoutPage } from './managePassesPage/BuyPassCheckoutPage';
import { CardUpdatedPage } from './managePassesPage/CardUpdatedPage';
import { CardUpdatePage } from './managePassesPage/CardUpdatePage';
import { PaymentLinksWizard } from './customerPaymentLinksPage/CustomerPaymentLinksPage';
import { AccountSpecificThemeWrapper } from './orderPage/components/AccountSpecificThemeWrapper';
import { OrderPageProvider } from './orderPage/orderPageContext/OrderPageProvider';
import { MultipleOrderPage } from './orderPage/multipleOrderPages/MultipleOrderPage';
import { VoucherSelectionWidget } from './orderPage/multipleVouchersPage';
import { CompleteRequestedOrder } from './completeRequestedOrder/CompleteRequestedOrder';
import { ProjectSelectionPage } from './projectSelection/ProjectSelectionPage';
import { StorefrontPage } from './storefront/storefrontPage/StorefrontPage';
import { StorefrontThemeWrapper } from './storefront/StorefrontThemeWrapper';
import { ExperiencePage } from './storefront/experiencePage/ExperiencePage';
import { PassExperiencePage } from './storefront/experiencePage/PassExperiencePage';
import { GiftCardPage } from './storefront/giftCardPage/GiftCardPage';
import { SessionOrigin } from './api';

const routes = [
  {
    path: '/',
    element: <Navigate to="/choose-order" />,
  },
  {
    path: '/order/completed',
    element: (
      <AccountSpecificThemeWrapper>
        <OrderCompletedPage />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/card-updated',
    element: (
      <AccountSpecificThemeWrapper>
        <CardUpdatedPage />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/update-card',
    element: (
      <AccountSpecificThemeWrapper>
        <CardUpdatePage />
      </AccountSpecificThemeWrapper>
    ),
  },
  { path: '/waiting-list/completed', element: <WaitingListCompletedPage /> },
  {
    path: '/choose-order/:accountId/',
    element: <ChooseOrderPage />,
  },
  {
    path: '/order/:accountId/',
    element: (
      <AccountSpecificThemeWrapper>
        <MultipleOrderPage />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/giftcards/:accountId',
    element: (
      <AccountSpecificThemeWrapper>
        <VoucherSelectionWidget />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/order/:accountId/:experienceId/:orderPageId',
    element: (
      <OrderPageProvider>
        <OrderPage />
      </OrderPageProvider>
    ),
  },
  {
    path: '/order/:accountId/:experienceId',
    element: (
      <OrderPageProvider>
        <OrderPage />
      </OrderPageProvider>
    ),
  },
  {
    path: '/order/:accountId',
    element: (
      <OrderPageProvider>
        <OrderPage />
      </OrderPageProvider>
    ),
  },
  {
    path: '/waiting-list/:accountId/:experienceId/:orderPageId/:persons/:date',
    element: (
      <AccountSpecificThemeWrapper>
        <WaitingList />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/manage-booking',
    element: <ManageBookingPage />,
  },
  {
    path: '/passes/:accountId?',
    element: <ManagePassesPage />,
    children: [
      { index: true, element: <PassLogin /> },
      { path: 'dashboard', element: <PassDashboard /> },
      { path: 'pass/:passId', element: <PassDetailView /> },
      { path: 'schedule', element: <PassSchedule /> },
      { path: 'buy', element: <BuyPassPage /> },
      { path: 'buy/:passOrderPageId', element: <BuyPassCheckoutPage /> },
    ],
  },
  {
    path: '/payment-link',
    element: (
      <CustomerFacingWidgetWrapper>
        <PaymentLinksWizard />
      </CustomerFacingWidgetWrapper>
    ),
  },
  {
    path: '/complete-requested/:accountId',
    element: (
      <AccountSpecificThemeWrapper>
        <CompleteRequestedOrder />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/project-selection/:accountId',
    element: (
      <AccountSpecificThemeWrapper useMonkeybookTheme>
        <ProjectSelectionPage />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/storefront/:accountId/:storefrontId',
    element: (
      <StorefrontThemeWrapper sessionOrigin={SessionOrigin.STOREFRONT}>
        <StorefrontPage />
      </StorefrontThemeWrapper>
    ),
  },
  {
    path: '/experience/:accountId/:orderPageId/:storefrontId?',
    element: (
      <StorefrontThemeWrapper sessionOrigin={SessionOrigin.EXPERIENCE_PAGE}>
        <ExperiencePage />
      </StorefrontThemeWrapper>
    ),
  },
  {
    path: '/pass/:accountId/:orderPageId/:storefrontId?',
    element: (
      <StorefrontThemeWrapper sessionOrigin={SessionOrigin.EXPERIENCE_PAGE}>
        <PassExperiencePage />
      </StorefrontThemeWrapper>
    ),
  },
  {
    path: '/giftcard/:accountId/:storefrontId?',
    element: (
      <StorefrontThemeWrapper sessionOrigin={SessionOrigin.EXPERIENCE_PAGE}>
        <GiftCardPage />
      </StorefrontThemeWrapper>
    ),
  },
  { path: '*', element: <div>Not found</div> },
];

export default routes;
